import { blendColors } from '../../../../orders/styles/blendColors';
import { useVizChartTheme } from '../../hooks/useVizChartTheme';
import { useVizFormatters } from '../../hooks/useVizFormatters';
import { BarChartBlock } from '../../viz.types';
import { getVizBars } from '../../viz.utils';

export const useBarChartBlock = (block: BarChartBlock) => {
  const formatters = useVizFormatters(block.format);
  const chartTheme = useVizChartTheme();
  const { from, to } = chartTheme.lineGradient;

  const { bars, total } = getVizBars({ bars: block.bars, format: block.format });

  return {
    formatters,
    barRadius: `${chartTheme.sliceCornerRadius}px`,
    total: total === null ? null : formatters.formatCompact(total),
    bars: bars.map((bar) => ({
      ...bar,
      background: `linear-gradient(90deg, ${from}, ${blendColors({ background: from, overlay: to, opacity: bar.ratio })})`,
    })),
  };
};
